export default "__VITE_ASSET__BaZ_xoig__"